import { uniqueId } from 'lodash';

import { TransactionLabel, TransactionLabelAttributes } from 'dashboard/models/transaction-label';
import {
  TransactionStatus,
  TransactionStatusAttributes,
  TransactionStatusRelationships,
  TransactionStatusState,
} from 'dashboard/models/transaction-status';
import {
  TransactionType,
  TransactionTypeAttributes,
  TransactionTypeFilterOption,
  TransactionTypeRelationships,
  TransactionTypeStatus,
} from 'dashboard/models/transaction-type';
import { ApiModel } from 'lib/interfaces/api';

export const generateTransactionLabelId = () => uniqueId('txnl_');
export const generateTransactionStatusId = () => uniqueId('txnst_');
export const generateTransactionTypeId = () => uniqueId('txntp_');

export function createMockTransactionLabel(
  attributes?: Partial<TransactionLabelAttributes>,
  id?: string,
): TransactionLabel {
  return {
    id: id || generateTransactionLabelId(),
    type: ApiModel.TransactionLabel,
    attributes: {
      'model-label': attributes?.['model-label'] || 'approved',
      'model-version': attributes?.['model-version'] || '0.1.2',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'external-label': attributes?.['external-label'] || null,
      'created-at': '2022-09-20T05:30:12.000Z',
      'updated-at': '2022-09-20T08:30:12.000Z',
    },
    relationships: {},
  };
}

export function createMockTransactionStatus(
  attributes?: Partial<TransactionStatusAttributes>,
  relationships?: Partial<TransactionStatusRelationships>,
  id?: string,
): TransactionStatus {
  return {
    id: id || generateTransactionStatusId(),
    type: ApiModel.TransactionStatus,
    attributes: {
      name: 'created',
      status: TransactionStatusState.Active,
      'created-at': '2022-09-20T05:30:12.000Z',
      'updated-at': '2022-09-20T08:30:12.000Z',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'deactivated-at': undefined,
      ...attributes,
    },
    relationships: {
      'transaction-type': {
        data: {
          type: ApiModel.TransactionType,
          id: 'transaction_type_id',
        },
      },
      ...relationships,
    },
  };
}

export function createMockTransactionType(
  attributes?: Partial<TransactionTypeAttributes>,
  relationships?: Partial<TransactionTypeRelationships>,
  id?: string,
): TransactionType {
  return {
    id: id || generateTransactionTypeId(),
    type: ApiModel.TransactionType,
    attributes: {
      'created-at': '2022-10-19T06:31:58.000Z',
      'updated-at': '2022-10-19T09:31:58.000Z',
      name: 'txn type',
      status: TransactionTypeStatus.Active,
      'field-schemas': [],
      'relation-schemas': [],
      'environment-id': '1',
      identifiers: [
        {
          key: 'email_address',
          config: {
            'case-sensitive': false,
            unique: true,
          },
          'display-name': 'Email Address',
        },
      ],
      ...attributes,
    },
    relationships: {
      'default-status': {
        data: {
          type: ApiModel.TransactionStatus,
          id: 'transaction_status_id',
        },
      },
      statuses: {
        data: [
          {
            type: ApiModel.TransactionStatus,
            id: 'transaction_status_id',
          },
        ],
      },
      ...relationships,
    },
  };
}

export function createMockTransactionTypeBasic(
  attributes?: Partial<TransactionTypeFilterOption>,
  id?: string,
): TransactionTypeFilterOption {
  return {
    id: id || generateTransactionTypeId(),
    'updated-at': '2022-10-19T09:31:58.000Z',
    name: 'txn type',
    status: TransactionTypeStatus.Active,
    ...attributes,
  };
}
